module.exports = __webpack_public_path__ + "static/media/honeycomb-logo-small-dark.ab46f1f3.png";